module.exports = __webpack_public_path__ + "static/socialproof-exit-popup-01ee853bad3bc1266030ebb29d1416d0.png";